"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageRouteList = void 0;
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _react = _interopRequireDefault(require("react"));
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsRouteList = require("../../components/DmsRouteList/DmsRouteList");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @Author: Jean Mira
 * @Date:   2023-09-15 16:34:09
 * @Last Modified by:   Fernando Schneider
 * @Last Modified time: 2024-05-03 16:42:24
 */

/**
 * DmsPageRouteList component displays a list of routes within a structured page layout.
 * It includes a breadcrumb navigation for Home, System, and Route List.
 */
const DmsPageRouteList = () => {
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "Route_list"
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("Route_list").d("Route List"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsRouteList.DmsRouteList, null))));
};
exports.DmsPageRouteList = DmsPageRouteList;